import { createSelector } from 'reselect'
import { groupArchiveListByDay } from 'features/list/utils'

const getArchiveWithoutUpdatesList = state => state.todolist.items.archiveWithoutUpdates.list
const getArchiveWithUpdatesList = state => state.todolist.items.archiveWithUpdates.list

export const getGroupedArchive = createSelector(
  [getArchiveWithoutUpdatesList, getArchiveWithUpdatesList],
  (withoutUpdatesList, withUpdatesList) => {
    const groups = groupArchiveListByDay(withoutUpdatesList)
    if (withUpdatesList.length > 0) {
      groups.updates = withUpdatesList
    }
    return groups
  }
)

export const getLastSortKey = createSelector(
  [getArchiveWithoutUpdatesList],
  list => {
    if (!list || list.length === 0) {
      return ''
    }
    const lastSortKey = list[list.length - 1].completionTimeSortKey
    return lastSortKey
  }
)



// WEBPACK FOOTER //
// ./src/features/todolist/store/selectors.js